import 'normalize.css'
import './scss/style.scss'
import '../blocks/footer-credit'
import '../blocks/card'
import '../blocks/logo'
import '../blocks/icon-blurb'
import '../blocks/staff-card'
import '../blocks/gallery-slider'

import Swiper from 'swiper/bundle'
import 'swiper/css/bundle'
import { Fancybox } from '@fancyapps/ui/dist/fancybox/'
import '@fancyapps/ui/dist/fancybox/fancybox.css'
// import { Carousel } from '@fancyapps/ui/dist/carousel/'
// import '@fancyapps/ui/dist/carousel/carousel.css'
// import { Autoplay } from '@fancyapps/ui/dist/carousel/carousel.autoplay.js'
// import '@fancyapps/ui/dist/carousel/carousel.autoplay.css'
;(function () {
  const getSlidesCount = swiperEl => {
    if (swiperEl.classList.contains('coziehomes-tour-slider')) {
      const count = parseInt(swiperEl.dataset.sliderCount, 10)
      return Math.max(count - 1, 1)
    }
    return 2 // Default
  }

  document.querySelectorAll('.swiper').forEach(el => {
    new Swiper(el, {
      initialSlide: 0,
      // loop: true,
      centeredSlides: true,
      slidesPerView: getSlidesCount(el),
      spaceBetween: 40,
      grabCursor: true,
      autoplay: {
        delay: 2500,
        disableOnInteraction: false
      },
      speed: 600,
      // Add these for better stability with loops
      observer: true,
      observeParents: true
    })
  })

  Fancybox.bind('[data-fancybox="property-gallery"]', {
    // Your custom options
  })

  const popupFormOpenerClass = indexLocalizeScripts.popup_form_class
  const popupBtns = document.querySelectorAll(`.${popupFormOpenerClass}`)
  const popupForms = document.querySelectorAll(
    `[data-opener-class="${popupFormOpenerClass}"]`
  )

  initPopupForm(popupBtns, popupForms)

  function initPopupForm (btns, forms) {
    if (!btns?.length || !forms?.length) return

    const form = forms[0]

    btns.forEach(btn => {
      btn.addEventListener('click', e => openPopup(e, form))
    })

    form.addEventListener('click', e => {
      const target = e.target
      if (target.classList.contains('popup_form_close') || target === form) {
        closePopup(e, form)
      }
    })
  }

  function openPopup (e, form) {
    e.preventDefault()
    form.classList.add('opened')
    form.style.display = 'flex'
  }

  function closePopup (e, form) {
    e.preventDefault()
    form.classList.remove('opened')
    form.style.display = 'none'
  }

  const haBookingWidget = document.querySelector('#hostaway-booking-widget')
  overrideBookingWidgetBtnUrl(haBookingWidget)

  function overrideBookingWidgetBtnUrl (widget) {
    if (!widget) return

    const widgetBtn = widget.querySelector('.hsbw-main-button')
    if (!widgetBtn) return

    console.log('booking widget will be redirected to properties archive page')

    // Number of days to shift the checkin date (0 = no shift, 1 = +1 day)
    const shiftCheckinDays = 1

    widgetBtn.addEventListener('click', function (e) {
      e.preventDefault()

      try {
        const url = new URL(widgetBtn.href)
        const q = Object.fromEntries(new URLSearchParams(url.search).entries())

        // Map values
        let location = q.city || q.location || ''
        location = slugify(location)

        let guests = q.numberOfGuests || q.numberOfGuests || q.guests || ''
        let checkin = q.start || q.checkin || ''
        let checkout = q.end || q.checkout || ''

        // Optional: shift checkin by N days
        if (shiftCheckinDays && checkin) {
          const d = new Date(checkin)
          if (!isNaN(d.getTime())) {
            d.setDate(d.getDate() + parseInt(shiftCheckinDays, 10))
            checkin = d.toISOString().slice(0, 10)
          }
        }

        // Build new URL
        const newUrl = new URL('https://sandbox1.websitetesting.co/properties/')
        newUrl.searchParams.set('location', location)
        newUrl.searchParams.set('type', '') // empty as requested
        newUrl.searchParams.set('guests', guests)
        if (checkin) newUrl.searchParams.set('checkin', checkin)
        if (checkout) newUrl.searchParams.set('checkout', checkout)

        const final = newUrl.toString()

        // If the original button opens in a new tab, preserve that behavior
        const target = widgetBtn.getAttribute('target')
        if (target === '_blank') {
          window.open(final, '_blank', 'noopener')
        } else {
          // Replace href and navigate
          widgetBtn.href = final
          window.location.href = final
        }
      } catch (err) {
        // If anything fails, fall back to original behavior
        console.warn('Failed to override booking URL', err)
        // Optionally allow default click to proceed:
        // window.location.href = widgetBtn.href
      }
    })
  }

  // Simple slugify: trim, lowercase, replace spaces with -, remove invalid chars
  function slugify (str) {
    if (!str) return ''
    return String(str)
      .trim()
      .toLowerCase()
      .replace(/\s+/g, '-')
      .replace(/[^a-z0-9\-]/g, '')
  }
})()
